export const projectIds = {
  kpk: 'aff1bf53-f002-4e11-a314-0ed6115aea2d',
  mgtc: '1da5af20-4c48-45db-ae9e-54953e010ff0',
  frutella: 'c960b616-7847-472f-9e16-e47941536fd7',
  maybank: '8003d8f9-f107-43ff-bd63-ad432e4d407c',
  danone: '5acbdd88-ea47-43dd-ad17-72f5ecec6a7f',
  asuransi_astra: '28fa58dc-6446-46bf-8ac0-176bc246c3d4',
  lionparcel: 'd2b8ba50-93f7-4d6e-b25e-37009e548949',
  ajaib: '4970c803-aa38-4257-86eb-e290ca165363',
  pertamina_patra_niaga: 'ac887772-ed72-4df5-b035-b867fe9b77d4',
  bni: 'c46c03fc-58b1-40df-9c8f-bb64f0b7da57',
  harita_nickel: '60207d29-aab5-438c-ba21-1623fcdf0605'
};
